import { render } from "./OneOnOneListCard.vue?vue&type=template&id=2300af20&scoped=true"
import script from "./OneOnOneListCard.vue?vue&type=script&lang=js"
export * from "./OneOnOneListCard.vue?vue&type=script&lang=js"

import "./OneOnOneListCard.vue?vue&type=style&index=0&id=2300af20&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2300af20"

export default script